import OrderAttempt from "./OrderAttempt"
import { OrderAttemptStore } from "./orderAttemptReducer"

function getStore(state): OrderAttemptStore {
    return state.orderAttemptReducer as OrderAttemptStore
}

export function getFailedOrderAttempts(state, priceListId): OrderAttempt[] {
    const orderAttempts = getStore(state).OrderAttempts
    return orderAttempts
        .map(o => new OrderAttempt(o))
        .filter(c => c.getPriceListId() == priceListId)
}


// WEBPACK FOOTER //
// ./src/state/price-list/orderAttemptSelectors.ts